import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { clientMaster } = stateEnum

const initialState = {
  selectedClient: {},
}

const clientMasterSlice = createSlice({
  name: clientMaster,
  initialState,
  reducers: {
    resetClientMaster: (state) => {
      state.selectedClient = []
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload
    },
  },
})

export const { resetClientMaster, setSelectedClient } =
  clientMasterSlice.actions
export default clientMasterSlice.reducer
